import PhysicalVerificationMonitor from 'ui-component/cards/PhysicalVerification/PhysicalVerificationMonitor';

const SDPVMonitorPage = () => {
    return <PhysicalVerificationMonitor />;
};

export default SDPVMonitorPage;
